import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { UAParser } from 'ua-parser-js'

import { BrowserOutdatedModal } from '@app/routing/modals/BrowserOutdated.modal'

import { useModal } from '@context/ModalsContext'

import { compareBrowserVersions } from '@utils/compare.utils'
import { isLoginPage as checkIfLoginPage } from '@utils/isLoginPage'
import { outDatedBrowserRoutes } from '@utils/path'

import { useLocallyPersistedState } from '@hooks/useStorage'

export const useBrowserOutdated = () => {
  const location = useLocation()
  const isLoginPage = checkIfLoginPage(location.pathname)
  const { open: openBrowserOutdatedModal } = useModal(BrowserOutdatedModal)

  const [browserOutdatedDisplay, setBrowserOutdatedDisplay] = useLocallyPersistedState(
    'isBrowserOutdatedModalDisplayed',
    false
  )

  useEffect(() => {
    if (browserOutdatedDisplay) {
      return
    }
    const isPageToBeVerified = () => outDatedBrowserRoutes?.includes(location?.pathname)
    if (isLoginPage || !isPageToBeVerified()) {
      return
    }

    const parser = new UAParser()
    const { browser } = parser.getResult()

    if (!(browser.name === 'Safari' || browser.name === 'Mobile Safari')) {
      return
    }
    if (!(compareBrowserVersions(browser.version as string, '15.3') <= 0)) {
      return
    }

    openBrowserOutdatedModal()
    setBrowserOutdatedDisplay(true)
  }, [
    isLoginPage,
    browserOutdatedDisplay,
    setBrowserOutdatedDisplay,
    location?.pathname,
    openBrowserOutdatedModal,
  ])
}
